var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 16C4 9.37258 9.37258 4 16 4C17.1046 4 18 3.10457 18 2C18 0.895431 17.1046 7.47664e-07 16 6.99382e-07C7.16344 3.13124e-07 -3.13124e-07 7.16344 -6.99382e-07 16C-1.08564e-06 24.8366 7.16344 32 16 32C20.9205 32 25.3237 29.7764 28.2556 26.2865C28.9661 25.4407 28.8564 24.1792 28.0107 23.4687C27.165 22.7582 25.9034 22.8678 25.1929 23.7135C22.9885 26.3375 19.6894 28 16 28C9.37258 28 4 22.6274 4 16Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C14 3.10457 14.8954 4 16 4C22.6274 4 28 9.37258 28 16C28 17.1046 28.8954 18 30 18C31.1046 18 32 17.1046 32 16C32 7.16345 24.8366 4.73681e-07 16 8.74228e-08C14.8954 3.91405e-08 14 0.89543 14 2Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13,
    y1: -3,
    x2: 35.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BDCD",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900138,
    stopColor: "#CDD6E3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD6E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 33.5,
    y1: 13.5,
    x2: 15,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EDB"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.8c12f6caadf8a36bb163462fc4c59458.svg";
export { ForwardRef as ReactComponent };